<template>
  <div id="convenios" class="about-wrap style2 pt-0">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-img-wrap">
            <img
              class="about-img-one"
              src="../../assets/images/about/about-img-12.jpg"
              alt="Image"
            />
          </div>
        </div>
        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-content">
            <div class="content-title style1">
              <span>Convenios con nuestra Optica</span>
              <h2>
                Conoce nuestros convenios para empresas y empleados asegurados
              </h2>
              <p>
                Encuentra el servicio que mejor se adapte a las necesidades de tu empresa. Desde convenios con aseguradoras hasta lentes de seguridad graduados.
              </p>
            </div>
            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-clinic"></i>
                </div>
                <div class="feature-text">
                  <h3 style="font-size: 1.25rem;">Convenios con Aseguradoras</h3>
                  <p>
                    Descubre nuestros convenios exclusivos para empleados asegurados.
                  </p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-stethoscope"></i>
                </div>
                <div class="feature-text">
                  <h3 style="font-size: 1.25rem;">Convenios Escolares y Universitarios</h3>
                  <p>
                    Apoya a la educación con convenios diseñados para estudiantes y personal académico.
                  </p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-charity"></i>
                </div>
                <div class="feature-text">
                  <h3 style="font-size: 1.25rem;">Convenios Gubernamentales</h3>
                  <p>
                    Servicios ópticos para instituciones públicas y su personal.
                  </p>
                </div>
              </div>
              <div class="hero-btn">
                <a href="#contacto" class="btn style2">Solicitar Visita</a>
              </div>
              
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HowWeWork",
};
</script>